const types = {
  SET_USER: 'SET_USER',

  INITIALISE_STORE: 'INITIALISE_STORE',
  ADD_LANGUAGE: 'ADD_LANGUAGE',
  ADD_TAG: 'ADD_TAG',
  ADD_TAG_TO_SNIPPET: 'ADD_TAG_TO_SNIPPET',
  ADD_SNIPPET: 'ADD_SNIPPET',
  DELETE_HISTORY: 'DELETE_HISTORY',

  EDIT_LANGUAGE_NAME: 'EDIT_LANGUAGE_NAME',
  FINISH_EDIT_LANGUAGE_NAME: 'FINISH_EDIT_LANGUAGE_NAME',

  SELECT_LANGUAGE: 'SELECT_LANGUAGE',
  SELECT_SNIPPET: 'SELECT_SNIPPET',
  SELECT_TAG: 'SELECT_TAG',

  REMOVE_LANGUAGE: 'REMOVE_LANGUAGE',
  REMOVE_SNIPPET: 'REMOVE_SNIPPET',
  REMOVE_TAG: 'REMOVE_TAG',
  REMOVE_TAG_FROM_SNIPPET: 'REMOVE_TAG_FROM_SNIPPET',

  UPDATE_LANGUAGE_NAME: 'UPDATE_LANGUAGE_NAME',
  UPDATE_SNIPPET: 'UPDATE_SNIPPET',

  SEARCH_SNIPPET: 'SEARCH_SNIPPET',

  UNDO: 'UNDO',
  UNDO_INCREMENT: 'UNDO_INCREMENT',

  UPDATE_USER_PREFERENCES: 'UPDATE_USER_PREFERENCES',
};

export default types;
